
import React, { useRef, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { InputMask, InputMaskChangeEvent } from 'primereact/inputmask';
import API from '../../api/API';
import { MdDomain, MdGroups } from 'react-icons/md';
import { PiKeyFill } from "react-icons/pi";
import { FcPhoneAndroid } from "react-icons/fc";
import { newPessoa, PessoaType } from '../../db/Orm';
import { IoIosMail } from "react-icons/io";

type RecuperarSenhaDialogProps = {
    visible: boolean;
    onHide: () => void;
    onSuccess: () => void;
};

const RecuperarSenhaDialog: React.FC<RecuperarSenhaDialogProps> = ({ visible, onHide, onSuccess }) => {
    const [pessoa, setPessoa] = useState<PessoaType>(newPessoa());
    const toast = useRef<Toast>(null);
    const [pj, setPJ] = useState(false);
    const [contato, setContato] = useState('celular');

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setPessoa({ ...pessoa, [name]: value });
    };

    const handleMaskChange = (e: InputMaskChangeEvent) => {
        const { name, value } = e.target;
        setPessoa({ ...pessoa, [name!]: value! });
    };

    const [loading, setLoading] = useState(false);

    const handleRecuperarSenha = async () => {
        if (pessoa.cpf_cnpj && (pessoa.celular || pessoa.email)) {
            setLoading(true);
            API.resetSenhaConfirmar(pessoa, toast.current, (success: boolean) => {
                setLoading(false);
                if (success) {
                    onSuccess();
                    onHide();
                }
            });
        } else {
            toast.current?.show({ severity: 'warn', summary: 'Atenção', detail: 'Preencha CPF/CNPJ e Celular ou Email.' });
        }
    };

    return (
        <Dialog header={<div style={{ display: 'flex', alignItems: 'center' }}><PiKeyFill style={{ marginRight: '10px' }} />Resetar Senha</div>} visible={visible} style={{ width: 300 }} onHide={onHide} modal>
            <Toast ref={toast} />
            <form onSubmit={(e) => { e.preventDefault(); handleRecuperarSenha(); }}>
                <div className="p-fluid">
                    <div className="p-field">
                        <label htmlFor="cpf_cnpj">{pj ? "CNPJ" : "CPF"}</label>
                        <div className="p-inputgroup">
                            <InputMask
                                id="cpf_cnpj"
                                name="cpf_cnpj"
                                mask={pj ? "99.999.999/9999-99" : "999.999.999-99"}
                                value={pessoa.cpf_cnpj}
                                onChange={handleMaskChange}
                                placeholder={pj ? "CNPJ" : "CPF"}
                            />
                            <span className="p-inputgroup-addon" onClick={() => setPJ(!pj)} style={{ cursor: 'pointer' }}>
                                {pj ? <MdDomain /> : <MdGroups />}
                            </span>
                        </div>
                        <label style={{fontSize: 12}}>Caso queira trocar, clique no ícone ao lado.</label>
                    </div>
                    <br />
                    <div className="p-field">
                        <label htmlFor={contato === 'celular' ? 'celular' : 'email'}>{contato === 'celular' ? 'Celular' : 'Email'}</label>
                        <div className="p-inputgroup">
                            {contato === 'celular' ? (
                                <InputMask
                                    id="celular"
                                    name="celular"
                                    mask="(99) 9 9999-9999"
                                    value={pessoa.celular}
                                    onChange={handleMaskChange}
                                    placeholder="Celular"
                                />
                            ) : (
                                <InputText
                                    id="email"
                                    name="email"
                                    value={pessoa.email}
                                    onChange={handleInputChange}
                                    placeholder="Email"
                                />
                            )}
                            <span className="p-inputgroup-addon" onClick={() => setContato(contato === 'celular' ? 'email' : 'celular')} style={{ cursor: 'pointer' }}>
                                {contato === 'celular' ? <FcPhoneAndroid /> : <IoIosMail />}
                            </span>
                        </div>
                        <label style={{ fontSize: 12 }}>Caso queira trocar, clique no ícone ao lado.</label>
                    </div>
                </div>
                <div style={{ 'textAlign': 'center', 'marginTop': '20px' }}>
                    <Button label="Recuperar Senha" icon="pi pi-check" type="submit" loading={loading} />
                </div>
            </form>
        </Dialog>
    );
};

export default RecuperarSenhaDialog;
